import { Box, Button, Link, Typography } from '@mui/material';
import { Badge, Modal } from '@care/react-component-lib';
import { useState } from 'react';
import { Icon24InfoBgcFilled } from '@care/react-icons';

const useBackgroundCheckModal = (openModal: boolean) => {
  const [open, setOpen] = useState(openModal);
  const BadgeModal = () => (
    <Modal
      open={open}
      variant="dynamic"
      hideClose
      onClose={() => {
        setOpen(false);
      }}
      title="Background Check">
      <Box mb={3} textAlign="left">
        <Badge icon={<Icon24InfoBgcFilled size="18px" />} text="Background Check" />
        <Typography variant="body3" color="primary">
          Has a current Criminal and/or Motor Vehicles Records background check.
        </Typography>
        <Link
          variant="body3"
          href="https://www.care.com/vis/safetyBackgroundChecks"
          target="_blank"
          rel="noreferrer">
          Learn about background check limitations
        </Link>
      </Box>
      <Button
        color="secondary"
        variant="contained"
        size="small"
        sx={{ display: 'block', margin: 'auto' }}
        onClick={() => {
          setOpen(false);
        }}>
        Close
      </Button>
    </Modal>
  );
  return [BadgeModal, setOpen, open] as const;
};
export default useBackgroundCheckModal;
